export { ButtonIconComponent } from './button-icon.component';
